import React, {Component} from "react"
import {Field, Form, Formik} from "formik"
import * as Yup from "yup"
import "./index.css"
import classNames from "classnames";


const encode = (data) => {
  return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
}

const RegisterInterestSchema = Yup.object().shape({
  name: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Name is required"),
  email: Yup.string()
      .email("Invalid email")
      .required("Email is required"),
});

const InputFeedback = ({error, touched}) => touched && error ? <div className="invalid-feedback">{error}</div> : null;

class RegisterInterestForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      feedback: false,
      errorMsg: false,
      isSending: false,
    }
  }


  render() {
    return (
        <React.Fragment>
          <Formik
              initialValues={{
                name: "",
                "bot-field": "",
                "form-name": "register-interest",
                email: "",
                message: "",
                title: "Android Coming Soon - Bay Watch Waitlist",
              }}
              validationSchema={RegisterInterestSchema}
              onSubmit={(values, actions) => {
                fetch("/?no-cache=1", {
                  method: "POST",
                  headers: {"Content-Type": "application/x-www-form-urlencoded"},
                  body: encode({"form-name": "register-interest", ...values})
                }).then(() => {
                  actions.setSubmitting(false)
                  this.setState({feedback: 'Sent!'})
                  actions.resetForm()
                }).catch(error => {
                  console.log(error)
                  this.setState({errorMsg: 'Error submitting form!'})
                });
              }}
          >
            {({
                errors, touched, setFieldValue,
                setFieldTouched,
                values,
              }) => (
                <Form id="register-interest" name="register-interest" method="POST" data-netlify="true">
                    <h5>Android coming soon — register to join the waitlist</h5>
                  <div className="form-group">
                    <Field
                        type="text"
                        name="name"
                        placeholder="Name"
                        className={
                          errors.name && touched.name
                              ? "form-control is-invalid"
                              : "form-control"
                        }
                    />
                    {<InputFeedback error={errors.name} touched={touched.name}/>}
                  </div>

                  <div className="form-group">
                    <Field
                        type="email"
                        name="email"
                        className={
                          errors.email && touched.email
                              ? "form-control is-invalid"
                              : "form-control"
                        }
                        placeholder="Your Email"
                    />
                    {<InputFeedback error={errors.email} touched={touched.email}/>}
                  </div>

                  <div className="form-group">
                    <Field
                        component="textarea"
                        name="message"
                        className={
                          errors.message && touched.message
                              ? "form-control is-invalid"
                              : "form-control"
                        }
                        placeholder="Your Message"
                        rows="4"
                    />
                    {<InputFeedback error={errors.message} touched={touched.message}/>}
                  </div>

                  {this.state.errorMsg && (
                      <div className="feedback-container text-danger">
                        <p>Something went wrong please try again.</p>
                      </div>
                  )}

                  {this.state.feedback && (
                      <div className="feedback-container text-primary">
                        <h5>Thank you!</h5>
                        <p>
                          Message sent.
                        </p>
                      </div>
                  )}

                  <div className="form-group">
                    <button
                        type="submit"
                        disabled={this.state.isSending}
                        className="btn form-btn">
                      {this.state.isSending && (
                          <i className="fa fa-refresh fa-spin"/>
                      )}{" "}
                      {this.state.isSending && <span>Sending....</span>}
                      {!this.state.isSending && <span> Send Message</span>}
                    </button>
                  </div>
                  <Field type="hidden" name="bot-field"/>
                  <Field type="hidden" name="form-name" value="register-interest"/>
                  <input name="bot-field" type="hidden"/>
                </Form>
            )}
          </Formik>
        </React.Fragment>
    )
  }
}

export default RegisterInterestForm
